/*
 * A/B cart attribution — first-party, no external calls.
 * ---------------------------------------------------------------------------
 * Stamps the visitor's A/B variant assignment onto the Shopify cart as
 * private (underscore-prefixed) cart attributes, so a completed order carries
 * which variant the buyer saw. Read `_sugar_ab` back from the order's
 * attributes to measure results.
 *
 * The ONLY network request this makes is a same-origin POST to
 * /cart/update.js. No visitor data leaves the store. The theme's other
 * analytics hooks (track / observe / flush / sessionOnce) are intentionally
 * inert no-ops here — they previously fed a vendor phone-home that was removed.
 * They stay defined (not undefined) so the theme's guarded call sites
 * `if (window.SugarAnalytics) window.SugarAnalytics.track(...)` never throw.
 */
(function () {
  'use strict';
  if (window.SugarAnalytics) return;

  function randomHex(len) {
    var out = '';
    try {
      var bytes = new Uint8Array(len / 2);
      crypto.getRandomValues(bytes);
      for (var i = 0; i < bytes.length; i++) out += (bytes[i] + 256).toString(16).slice(1);
    } catch (e) {
      while (out.length < len) out += Math.random().toString(16).slice(2);
    }
    return out.slice(0, len);
  }

  function visitorId() {
    try {
      var vid = localStorage.getItem('_sugar_vid');
      if (!vid || !/^[a-f0-9]{8,32}$/.test(vid)) {
        vid = randomHex(16);
        localStorage.setItem('_sugar_vid', vid);
      }
      return vid;
    } catch (e) {
      return randomHex(16);
    }
  }

  var vid = visitorId();

  function abAssignments() {
    try {
      var parsed = JSON.parse(localStorage.getItem('_sugar_ab') || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  // Write the A/B assignment onto the cart so it rides along to the order.
  // Deduped per session (unless forced) to avoid redundant cart writes.
  function syncCartAttributes(force) {
    var assignments = abAssignments();
    if (!Object.keys(assignments).length) return; // no test on this journey → nothing to attribute
    var serialized = JSON.stringify(assignments);
    if (!force) {
      try {
        if (sessionStorage.getItem('_sugar_ca_synced') === serialized) return;
      } catch (e) {
        // no sessionStorage; fall through and sync anyway
      }
    }
    var attrs = { _sugar_vid: vid, _sugar_ab: serialized };
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (r.ok) {
          try { sessionStorage.setItem('_sugar_ca_synced', serialized); } catch (e) {}
        }
      }).catch(function () {});
    } catch (e) {
      // network unavailable; the next page load retries
    }
  }

  function noop() {}
  function sessionOnce(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true;
    }
  }

  window.SugarAnalytics = {
    track: noop,                 // inert: no event collection
    observe: noop,               // inert: no impression tracking
    flush: noop,                 // inert: nothing queued to send
    sessionOnce: sessionOnce,    // harmless local dedupe helper
    abAssignments: abAssignments,
    syncAbCartAttribute: syncCartAttributes,
    syncCartAttributes: syncCartAttributes,
    vid: vid
  };

  // Neutralize the pre-load event queue so inline scripts that push to it
  // (before this file loads) don't accumulate an unbounded in-memory array.
  window._sugarQ = { push: noop };

  // If an A/B test rendered on this page, stamp the cart now.
  if (window._sugarAbOnPage) syncCartAttributes();
})();
